import React, { FunctionComponent } from 'react';

const SurveyTemplateIcon: FunctionComponent<
  React.PropsWithChildren<{ large?: boolean; color?: string }>
> = ({ large = false, color = '#555555' }) => {
  if (large) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0759 9.90961L23.1559 18.9896C23.5559 19.3896 23.5559 20.0196 23.1559 20.3996L20.8559 22.6996C20.4659 23.0896 19.8359 23.0896 19.4459 22.6996L10.3359 13.5896C8.01586 14.4596 5.30586 13.9696 3.44586 12.1096C1.14586 9.8196 0.93586 6.2296 2.79586 3.6896L6.62586 7.51961L8.04586 6.1096L4.20586 2.25961C6.75586 0.399605 10.3359 0.609605 12.6359 2.90961C14.5259 4.80961 15.0059 7.5696 14.0759 9.90961ZM10.6959 11.1296L20.1559 20.5896L21.0359 19.6996L11.5859 10.2496C12.0459 9.65961 12.3459 8.99961 12.4659 8.28961C12.7159 6.89961 12.3059 5.40961 11.2259 4.32961C10.2759 3.38961 9.02586 2.9496 7.78586 3.0196L10.8759 6.1096L6.63586 10.3496L3.54586 7.2596C3.47586 8.49961 3.91586 9.75961 4.86586 10.6996C5.90586 11.7396 7.33586 12.1496 8.69586 11.9496C9.40586 11.8496 10.0859 11.5796 10.6959 11.1296Z"
          fill={color}
        />
      </svg>
    );
  }
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05061 6.60632L15.1039 12.6597C15.3706 12.9263 15.3706 13.3463 15.1039 13.5997L13.5706 15.133C13.3106 15.393 12.8906 15.393 12.6306 15.133L6.55728 9.05966C5.01061 9.63966 3.20395 9.31299 1.96395 8.07299C0.430614 6.54632 0.290614 4.15299 1.53061 2.45966L4.08395 5.01299L5.03061 4.07299L2.47061 1.50632C4.17061 0.266322 6.55728 0.406322 8.09061 1.93966C9.35061 3.20632 9.67061 5.04632 9.05061 6.60632ZM6.79728 7.41966L13.1039 13.7263L13.6906 13.133L7.39061 6.83299C7.69728 6.43966 7.89728 5.99966 7.97728 5.52632C8.14395 4.59966 7.87061 3.60632 7.15061 2.88632C6.51728 2.25966 5.68395 1.96632 4.85728 2.01299L6.91728 4.07299L4.09061 6.89966L2.03061 4.83966C1.98395 5.66632 2.27728 6.50632 2.91061 7.13299C3.60395 7.82632 4.55728 8.09966 5.46395 7.96632C5.93728 7.89966 6.39061 7.71966 6.79728 7.41966Z"
      />
    </svg>
  );
};

export default SurveyTemplateIcon;
